import { call, all, put, select, takeLatest } from "redux-saga/effects";
import { normalize, schema } from "normalizr";
import { showError } from "../../utils/sagasErrorHandler";
import { setCountries, getCountries } from "./actions";
import { getCountriesRequest } from "./api";
import { countriesSelector } from "./selectors";

const countriesSchema = new schema.Entity("countries",{}, { idAttribute: "iso_code2" });
const countriesListSchema = new schema.Array(countriesSchema);

function* getCountriesWorker() {
    try {
        const { ids } = yield select(countriesSelector);
        if(!ids.length){
            yield put(setCountries({ isLoading: true }));
            const { countries } = yield call(getCountriesRequest);
            const { result, entities } = normalize(countries, countriesListSchema);
            yield put(setCountries({
                isLoading: false,
                countries: entities.countries,
                ids: result
            }));
        }
    } catch (error) {
        yield put(setCountries({ isLoading: false }));
        showError(error);
    }
}

export function* getCountriesSaga() {
    yield all([
        yield takeLatest(getCountries, getCountriesWorker)
    ]);
}
